<template>
  <button
    type="button"
    class="bui-nav-toggle"
    :aria-label="ariaLabel"
    :aria-pressed="pressed"
    @click="emit('click', $event)"
  >
    <NavIco :size="navIcoSize">
      <PhList weight="bold" />
    </NavIco>
  </button>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import NavIco from '../NavIco/NavIco.vue';
import { PhList } from '@phosphor-icons/vue';
import useIsMobile from '@/composables/utils/isMobile';

const isMobile = useIsMobile();
const navIcoSize = computed(() => (isMobile.value ? 32 : 40));

withDefaults(
  defineProps<{
    pressed?: boolean;
    ariaLabel?: string;
  }>(),
  { pressed: false, ariaLabel: 'Toggle navigation' },
);

const emit = defineEmits<{ click: [event: MouseEvent] }>();
</script>

<style lang="scss" scoped>
.bui-nav-toggle {
  display: inline-flex;
  align-items: center;
  padding: var(--nav-padding-box, 8px);
  border: 0;
  background: transparent;
  color: var(--nav-label-primary, #f6f7ff);
  border-radius: var(--nav-radius-box, 12px);
  cursor: pointer;

  &:hover {
    background: var(--nav-btn-hover, #8e3fbc);
  }

  &:focus-visible {
    outline: 2px solid var(--nav-label-primary, #f6f7ff);
    outline-offset: 2px;
  }
}
</style>
